module.exports = __webpack_public_path__ + "img/icon-a-5.64b5db8c.svg";